import Image from 'next/image';
import { BlurInH2 } from '../../eldora-ui/blur-in-h2';

export default function CertificationBanner() {
  return (
    <section
      className="max-w-8xl mx-auto flex flex-col lg:flex-row justify-center gap-x-8 bg-white"
      style={{ scrollMarginTop: '150px' }}
    >
      <div className="grid grid-cols-1 lg:grid-cols-5 mt-10">
        <div className="col-span-1"></div>
        <div className="col-span-1 mx-auto">
          <BlurInH2 className="mt-2 w-[50%] text-[#BF984D]">
            Simplicity<sup>®</sup>{' '}
            <span className="font-light">Certification</span>
          </BlurInH2>
          <span className="block text-base">
            Anacle has certification paths for many professional services roles.
            Each of these certifications require you to attend courses and
            potentially passing a series of tests to earn the certification.
            <br />
            <br />
            Become a trusted Simplicity® expert today.
          </span>
        </div>
        <div className="px-5 col-span-3 pt-10 md:pt-0">
          <Image
            src={'/background-professional services providers 2.svg'}
            alt={'Feature image'}
            className="h-full object-cover w-full"
            width={700}
            height={400}
          />
        </div>
      </div>
    </section>
  );
}
